import { Alert, Button } from "@mui/material";
import { Checkbox, Grid, Paper, MenuItem, Select } from "@mui/material";
import { useState, useEffect, useCallback, useContext, Suspense, useMemo } from "react";
import { CustomInput, CustomSelectInput } from "../../../../../shared/CustomInput";
import { CoveredDependents } from "../../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../../shared/enrollment/planCode/PlanHeader";
import {
	AuthContext,
	GroupEnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../contexts";
import { CoverageDetails } from "../../../../../shared/enrollment";
import { useHistory, useLocation } from "react-router-dom";
import CONTACT_LABELS from "../../../../../../constants/contactLabels";
import { dateTimeZoneConverter, manualDateComparator } from "../../../../../../utils/commonFunctions/date";

import LinkIcon from "@mui/icons-material/Link";

import "./healthPlanForm.css";
import { PlanFormProps } from "../../../../../../types/components/enrollmentProps.types";
import { getHealthPlanEligibleDependents } from "../../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Member } from "../../../../../../types/employee.types";
import { PremiumRateCoverage } from "../../../../../../types/plan.types";
import { numberToDollarStr } from "../../../../../../utils/commonFunctions/dollar";
import { CommonDetails, CoverageCode, StandardDetails } from "../../../../../../types/enrollment.types";
import { RELATIONSHIP } from "../../../../../../constants/relationship";
import { AddEnrollmentPayload } from "../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../utils/api";
import { EligiblityDialogProps } from "../../../../../../types/components/eligiblityDialogProps.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import { DisclaimerTable, LazyCustomFormDialog, LazyCustomTextAreaInput } from "../../../../../shared";
import { getCurrentDate } from "../../../../../../utils/commonFunctions/date";
import EligiblityDialog from "../../../../VEBEnrollment/eligiblityDialogs/EligiblityDialog";
import { Health_Plan_Brochure_SBC } from "../../../../../../assets";
import ExistsEnrollmentModel from "../../../../../shared/existsMemberModel/ExistsEnrollmentModel";
import ExistsDependentModel from "../../../../../shared/existsMemberModel/ExistDependentModel";

const HealthPlanForm = ({
	dependents,
	isActiveEnrollment,
	openEnrollment,
	getEnrollmentInitData
}: PlanFormProps): JSX.Element => {
	const history = useHistory();
	const { member } = useContext(AuthContext);
	const [waiveReason, setWaiveReason] = useState("");
	const [isModelOpen, setIsModelOpen] = useState(false);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const [isDependentExists, setIsDependentExists] = useState(false);
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const { paycheck } = useContext(PaycheckContext);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const [coveredDependents, setCoveredDependents] = useState<Member[]>([]);
	const { theme } = useContext(ThemeContext);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		groupPlanName: "Health Plan"
	});
	const [country, setCountry] = useState(["a", "b"]);
	const [anotherInsurance, setAnotherInsurance] = useState<any>({
		has_another_group_insurance: false,
		another_group_insurance: null
	});
	const location = useLocation();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { groupOwner } = useContext(GroupOwnerContext);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateHealthPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);

		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}

		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};
		const response = await api.enrollment.addEnrollment(enrollmentPayload);
		const step = urlSearchParams.get("step");
		if (response) {
			getEnrollmentInitData(false);
		}
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveReason]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const checkMemberEnrollment = async (member: Member) => {
		const selectedMemberSSN = member?.SSN;
		const employee_SSN = member?.employee_SSN;
		const payload = {
			member_SSN: selectedMemberSSN,
			employee_SSN: employee_SSN
		};
		// console.log("selectedMemberSSN", selectedMemberSSN);
		// console.log("PAYLOADFORTHEEMPLOYEECHECK-->", member.employee_SSN);
		if (!selectedMemberSSN) {
			console.error("No SSN found");
			return;
		}

		try {
			// console.log("APIPAYLOAD--->", selectedMemberSSN);

			const response = await api.member.getExistsMemberEnrollemnt(payload);
			if (response) {
				setIsDependentExists(true);
				setExistsDependentData(response.member);
				setIsModelOpen(true);
				return true;
			}
			// console.log("APIRESPONSEFORTHEHEALTH", response);
		} catch (err) {
			console.error("Error:", err);
		}
	};

	const handleSelectDependent = useCallback(async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		// console.log("dependent", dependent);
		if (checked === true) {
			await checkMemberEnrollment(dependent);
			setCoveredDependents((prevCoveredDependents: Member[]) =>
				Object.assign([], [...prevCoveredDependents, dependent])
			);
		} else {
			setIsDependentExists(false);
			setCoveredDependents((prevCoveredDependents: Member[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				return _selectedDependents;
			});
		}
	}, []);
	// useEffect(() => {
	// 	checkMemberEnrollment();
	// }, [coveredDependents]);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];
		if (openEnrollment === null || paycheck === null) {
			return;
		}
		const {
			plan: { coverage }
		} = openEnrollment;
		if (coverage.EE.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EE);

			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount
			});
		}
		if (coverage.ES.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ES);
			_coverageDetails.push({
				coverage: "Coverage For Spouse",
				premiumAmount
			});
		}
		if (coverage.EC.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EC);
			_coverageDetails.push({
				coverage: "Coverage For One Child",
				premiumAmount
			});
		}
		if (coverage.ECH.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ECH);
			_coverageDetails.push({
				coverage: "Coverage For Two or More Children",
				premiumAmount
			});
		}
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, openEnrollment, paycheck]);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const calculatePremium = useCallback(() => {
		if (openEnrollment === null || paycheck === null) {
			return null;
		}

		const coveredChildren: Member[] = [];
		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | any = null;
		let basePayRate: number;
		if (paycheck?.pay_frequency === "WEEKLY") {
			basePayRate = paycheck.weekly_base_rate;
		} else if (paycheck?.pay_frequency === "MONTHLY") {
			basePayRate = paycheck.monthly_base_rate;
		} else {
			alert("Invalid Pay Frequency");
			return;
		}
		let employeePremium: number | null = 0;
		employeePremium = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.EE);
		if (employeePremium === null) {
			return;
		}
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});
		const coverageCode = coveredSpouse && coveredChildren.length !== 0 ? "EF" : coveredSpouse ? "ES" : "ECH";
		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;
		if (coveredDependents.length !== 0) {
			if (coveredSpouse !== null) {
				const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ES);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false
				};
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = _dependentPremium + premiumAmount;
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.EC);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const spouseStandardDetails: StandardDetails = {
						member_object_id: coveredChildren[0]._id,
						coverage_code: "EC",
						member_SSN: coveredChildren[0].SSN,
						premium_amount: premiumAmount,
						is_tobacco: false
					};
					_dependentPremium = _dependentPremium + premiumAmount;
					standardDetails.push(spouseStandardDetails);
				} else {
					const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ECH);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails = {
							member_object_id: coveredChild._id,
							coverage_code: "ECH",
							member_SSN: coveredChild.SSN,
							premium_amount: premiumAmount,
							is_tobacco: false
						};
						standardDetails.push(spouseStandardDetails);
					});
					_dependentPremium = _dependentPremium + premiumAmount;
				}
			}
			setEnrollmentStandardDetails(Object.assign([], standardDetails));
			setDependentPremium(_dependentPremium);
		}
		setTotalPremium(employeePremium + _dependentPremium);
		setEmployeePremium(employeePremium);
	}, [calculatePremiumByCoverage, coveredDependents, openEnrollment, paycheck]);
	// console.log("ISTRUECHECK1--->", isDependentExists);
	const handleActivateButtonClick = useCallback(async () => {
		// Check if any dependents are selected
		// console.log("ISTRUECHECK2--->", isDependentExists);
		if (isDependentExists === true) {
			// alert(`Please deselect the dependent${existsDependentData.first_name} to proceed`);
			setIsDependentExistsModelOpen(true);
			return; // Exit the function early if a dependent exists
		}
		if (member === null || openEnrollment === null) {
			return;
		}

		const currentDate = new Date() as unknown as string;
		const planStartDate = openEnrollment.plan.start_date; // -1 or 0
		const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

		const effectiveDate = openEnrollment.plan.auto_approve
			? planDateComparison === -1 || planDateComparison === 0
				? getCurrentDate()
				: null
			: null;

		const _another_group_insurance: string = anotherInsurance.another_group_insurance
			? anotherInsurance.another_group_insurance.replace(/\n/g, " ")
			: "";

		const enrollmentCommonDetails: CommonDetails = {
			agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
			location_number: member.location.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: openEnrollment.plan._id,
			plan_code: openEnrollment.plan.plan_code,
			plan_name: openEnrollment.plan.plan_name,
			base_plan_name: openEnrollment.plan.plan_name,
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			writing_number: 0,
			unenrolled_reason: null,
			waive_reason: null,
			termination_reason: null,
			enrollment_date: getCurrentDate(),
			effective_date: effectiveDate,
			termination_date: null,
			open_enrollment_id: openEnrollment._id,
			total_premium: totalPremium,
			another_group_insurance: _another_group_insurance
		};

		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | any = null;
		const coveredChildren: Member[] = [];
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});

		const coverageCode =
			coveredSpouse === null && coveredChildren.length === 0
				? "EE"
				: coveredSpouse && coveredChildren.length !== 0
				? "EF"
				: coveredSpouse
				? "ES"
				: "ECH";

		const enrollmentPayload: AddEnrollmentPayload = {
			common_details: enrollmentCommonDetails,
			standard_details: [
				...enrollmentStandardDetails,
				{
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount: employeePremium,
					is_tobacco: false
				}
			]
		};

		const resp = await api.enrollment.addEnrollment(enrollmentPayload);
		const step = urlSearchParams.get("step");
		getEnrollmentInitData(false);
		history.push(`?step=${step}&stage=2`);
	}, [
		anotherInsurance.another_group_insurance,
		coveredDependents,
		employeePremium,
		isDependentExists,
		enrollmentStandardDetails,
		getEnrollmentInitData,
		groupOwner,
		history,
		member,
		openEnrollment,
		totalPremium,
		urlSearchParams
	]);

	const handleChangeOtherInsurance = useCallback(
		(event: any) => {
			const { name, value, checked } = event.target;

			if (name === "has_another_group_insurance") {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: checked }));
			} else {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: value }));
			}
		},
		[anotherInsurance]
	);

	const redirectBrochureDownloiad = () => {
		const pdfURL = Health_Plan_Brochure_SBC;
		const pdfTitle = "Health_Plan_Brochure SBC";
		window.open(pdfURL, pdfTitle);
	};

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	useEffect(() => {
		if (openEnrollment) {
			const dependentCoverage = getHealthPlanEligibleDependents(dependents, openEnrollment.plan.coverage);
			// console.log("DependentCoverage", dependentCoverage);
			setEligibleDependents(Object.assign([], dependentCoverage.eligibleDependents));
			getCoverageDetails();
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: true,
					eligibleDependents: Object.assign([], dependentCoverage.eligibleDependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});
		}
	}, [dependents, getCoverageDetails, openEnrollment]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, coveredDependents.length]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	// // console.log("anotherInsurance", anotherInsurance);
	// console.log("covereddependentselected--->", coveredDependents);

	return (
		<>
			<div className="health-benefit">
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog
							customFormDialogProps={customFormDialogProps}
							planName={openEnrollment?.plan.plan_name}
						/>
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<PlanHeader planName={"Health Plan"} planCode={openEnrollment?.plan.plan_code} />
						<div className="theme-plan-section-margin" />
						<CoverageDetails coverageDetails={coverageDetails} />
						<div className="theme-plan-section-margin" />
						{eligibleDependents.length > 0 ? (
							<CoveredDependents
								dependents={eligibleDependents}
								handleSelectDependent={handleSelectDependent}
							/>
						) : (
							<div className="grid-actions-container">
								<div className="grid-action-margin" />
								<Button
									variant="contained"
									className="plan-action-button"
									style={{
										float: "right",
										marginBottom: "1rem",
										color: theme.button.color,
										backgroundColor: theme.button.background_color
									}}
									onClick={handleAddDependentClick}
								>
									Add Dependent
								</Button>
							</div>
						)}
						<div className="details-form-row" style={{ marginTop: "4rem", width: "100%" }}>
							<div className="details-form-label  required">Premium Amount</div>
							<CustomInput
								value={numberToDollarStr(totalPremium.toFixed(2) as unknown as number)}
								disabled
							/>
						</div>

						<div className="theme-plan-section-margin" />

						<div className="theme-plan-option-content theme-plan-section-margin">
							<Checkbox
								onClick={handleChangeOtherInsurance}
								name="has_another_group_insurance"
								checked={anotherInsurance.has_another_group_insurance}
								style={{ paddingLeft: 0 }}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>ARE YOU OR YOUR DEPENDENTS COVERED UNDER ANOTHER GROUP INSURANCE POLICY</strong>
							</p>
						</div>
						<div>
							{anotherInsurance.has_another_group_insurance ? (
								<Suspense fallback={<div />}>
									<LazyCustomTextAreaInput
										name="another_group_insurance"
										value={anotherInsurance.another_group_insurance}
										onChange={handleChangeOtherInsurance}
										placeholder="Please mention the details here . . ."
									/>
								</Suspense>
							) : null}
						</div>

						{openEnrollment?.plan.plan_code === "HP-FT-2023" ||
						openEnrollment?.plan.plan_code === "HP-PTIN-2023" ? (
							<div className="disclaimer-container">
								<Alert severity="warning" sx={{ fontSize: "1rem" }}>
									<div className="disclaimer-message">
										Disclaimer:{" "}
										<strong className="disclaimer">
											After May 1, 2024 all Health Plan payroll deductions will be updated to
											reflect the new rates for the Plan year as shown below:
										</strong>
									</div>
									<DisclaimerTable payFrequency={paycheck?.pay_frequency} />
								</Alert>
							</div>
						) : null}

						<div className="theme-plan-section-margin" />
						<div className="external-links">
							<div>
								<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
							</div>
							<div className="header">
								To Know More About The Benefits Offered,{" "}
								<a href="#" onClick={redirectBrochureDownloiad}>
									Click Here
								</a>
							</div>
						</div>
						<div className="theme-plan-option-content theme-plan-section-margin">
							<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
							<p className="theme-plan-checkbox-label">
								<strong>
									I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
									THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
								</strong>
							</p>
						</div>
						<div className="theme-plan-section-margin" />
						<Grid container className="theme-plan-section-margin">
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Signature</div>
									<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
								</div>
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Date</div>
									<CustomInput value={dateTimeZoneConverter(getCurrentDate())} disabled />
								</div>
							</Grid>
						</Grid>
						<div className="theme-plan-section-margin" />
						<PlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
			{isModelOpen && <ExistsEnrollmentModel onClose={() => setIsModelOpen(false)} />}
			{isDependentExistsModelOpen && (
				<ExistsDependentModel
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default HealthPlanForm;
